<template>
  <button
    class="w-full rounded bg-white"
    :class="collapsed ? 'min-h-10 min-w-10 p-3' : 'flex gap-2 px-8 py-1'"
    :title="title"
    @click="setOpen(true)"
  >
    <span class="block w-4" :class="{ 'mx-auto': collapsed }">
      <slot name="icon"></slot>
    </span>
    <span
      class="text-sm font-bold capitalize max-sm:hidden"
      :class="{ hidden: collapsed }"
    >
      {{ title }}
    </span>
    <slot name="modal" :open="open" :handleClose="handleClose" />
  </button>
</template>
<script setup lang="ts">
import type { IParagraphEntry } from "~/models/IUserEntry";

type Props = {
  collapsed: boolean;
  title: string;
  type?: IParagraphEntry["type"];
};

const props = defineProps<Props>();

const { active } = useFetchActiveEntry();
const { setActive } = useSetActiveEntry();
const { isSmallerThanLg } = useLexMeaTailwindBreakpoints();

const activeIsType = computed(() =>
  Boolean(props.type && active.value?.type === props.type)
);

const [open, setOpen] = useToggle(activeIsType.value && isSmallerThanLg.value);

whenever(logicAnd(activeIsType, isSmallerThanLg), () => {
  setOpen(true);
});

const handleClose = () => {
  setOpen(false);
  setActive(undefined);
};
</script>
